import React from 'react';
import PropTypes from 'prop-types';

import Button from './Button';
import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';

const SliderButton = (props) => {
  const {
    onClick,
    animateArrow,
    right,
  } = props;

  return (
    right
      ? (
        <Button onClick={onClick}>
          <ArrowRight animate={animateArrow} />
        </Button>
      )
      : (
        <Button onClick={onClick}>
          <ArrowLeft animate={animateArrow} />
        </Button>
      )
  );
};

SliderButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  animateArrow: PropTypes.bool,
  right: PropTypes.bool,

};

SliderButton.defaultProps = {
  animateArrow: false,
  right: false,
};

export default SliderButton;



// WEBPACK FOOTER //
// ./src/blocks/SliderButtons/SliderButton.jsx